export namespace Url {
  export function getLocation(): Location {
    return window.location;
  }

  export function getUrl(): string {
    return getLocation().href;
  }

  export function getUnhashedUrl(url = getUrl()) {
    url = url || window.location.href;
    const hashIndex = url.indexOf('#');
    return url.substring(0, hashIndex > -1 ? hashIndex : url.length);
  }

  export function htmlEscape(str: string) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  export function getParameterByName(name: string, url = getUrl()): string {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results || !results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  export function getQueryString(url = getUrl()) {
    let questionIndex;
    let r = window.location?.search?.substring(
      1,
      window.location.search.length
    );
    if (url) {
      url = getUnhashedUrl(url);
      questionIndex = url.indexOf('?');
      r = questionIndex > -1 ? url.substring(questionIndex + 1) : '';
    }
    return r;
  }

  export function getUrlParams(url = getUrl()) {
    const qs: string = getQueryString(url);
    let r: { [key: string]: any } | null = null;
    let paramPairs;
    let keyValuePair: string[] | null;
    if (qs) {
      paramPairs = decodeURIComponent(qs).split('&');
      for (let i = 0, iLen = paramPairs.length; i < iLen; i++) {
        if (!r) {
          r = {};
        }
        keyValuePair = paramPairs[i].split('=');
        if (keyValuePair.length > 2) {
          keyValuePair[1] = paramPairs[i].split('=').slice(1).join('=');
        }
        r[keyValuePair[0]] =
          keyValuePair.length > 1 ? decodeURIComponent(keyValuePair[1]) : null;
      }
    }
    return r;
  }
}
